import * as actionTypes from '../actions/actionTypes';

const initState = {
  loading: false,
  items: [],
};

const deleteItems = state => {
  const object = state.find(e => e.id === 0 && e.name === null);
  const idx = state.indexOf(object);
  if (idx !== -1) return state.filter((e, id) => id !== idx);
  else return state;
};

const fetchRooms = (state, rooms) => {
  const roomLen = rooms.length;
  const itemLen = state.length;
  const bufferItems = [];

  if (itemLen !== roomLen) {
    const diff = itemLen - roomLen;
    for (let i = 0; i <= diff - 1; i++) {
      bufferItems.push({ id: 0, name: null, updated_at: 0, created_at: 0 });
    }
  }

  return [...rooms, ...bufferItems];
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ROOMS_START:
      return { ...state, loading: true };
    case actionTypes.FETCH_ROOMS_END:
      const {
        data: { rooms },
      } = action;
      return {
        ...state,
        loading: false,
        items: fetchRooms(state.items, rooms),
      };
    case actionTypes.ADD_ROOM_STORE:
      return {
        ...state,
        items: [...state.items, { id: 0, name: null, updated_at: 0, created_at: 0 }],
      };
    case actionTypes.ADD_ROOM_START:
      return { ...state, loading: true };
    case actionTypes.ADD_ROOM_SERVER:
      return { ...state, loading: false };
    case actionTypes.DELETE_ROOM_STORE:
      const { items } = state;
      return {
        ...state,
        items: deleteItems(items),
      };
    case actionTypes.DELETE_ROOM_START:
      return { ...state, loading: true };
    case actionTypes.DELETE_ROOM_SERVER:
      return { ...state, loading: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/room.js